import Backbone from "backbone";
import $ from "jquery";
import flowUtils from "../flowUtils";
import App from "app";
import { componentDnDDataTransfer } from "../leftSidebar/Components/componentDnD.utils";

export default Backbone.Marionette.LayoutView.extend({
    baseHandleDragover: function(e) {
        e.preventDefault(); // This is required to allow dropping
        e.stopPropagation(); // To show drop effect (cursor)

        const _this = this;

        // Cursor modification
        e.originalEvent.dataTransfer.dropEffect = _this.el.classList.contains("dnd-active" /* Drop allowed */)
            ? "link"
            : "none";
    },

    baseHandleDrop: function(e) {
        if (!e.originalEvent?.dataTransfer) return; // E.g. select area

        e.preventDefault();

        // Disables GraphNodesView.handleDrop, to not create 2 times same component
        e.stopPropagation();

        const name = e.originalEvent.dataTransfer.getData(componentDnDDataTransfer.name);
        if (!name) return;
        const type = e.originalEvent.dataTransfer.getData(componentDnDDataTransfer.type);
        if (!type) return;

        const _this = this;

        App.vent.trigger("fd:drop-with-assign", {
            type: type,
            name: name,
            model: _this.model
        });
    },

    baseHandleDragenter: function(e) {
        if (e.target.classList.contains("dnd-active" /* Drop allowed */)) {
            e.target.classList.add("active");
        }
    },

    baseHandleDragleave: function(e) {
        if (e.relatedTarget && e.target.contains(e.relatedTarget)) {
            // Moving in a child, ignore
            return;
        }

        if (e.target.classList.contains("active")) {
            e.target.classList.remove("active");
        }
    },

    setDragDropState: function(dragDropState) {
        this.$el.data("dndState", dragDropState);

        if (dragDropState === flowUtils.DRAG_DROP_STATE.INACTIVE) {
            this.$el.removeClass("dnd-active");
            this.$el.removeClass("dnd-not-allowed");
            return;
        }

        if (dragDropState === flowUtils.DRAG_DROP_STATE.ACTIVE) {
            this.$el.addClass("dnd-active");
            return;
        }

        if (dragDropState === flowUtils.DRAG_DROP_STATE.NOT_ALLOWED) {
            this.$el.addClass("dnd-not-allowed");
        }
    },

    addClipboardListener: function() {
        this.listenTo(this.model, "change:isInClipboard", function() {
            this.$el.toggleClass("component-cut", this.model.isInClipboard === true && this.model.isCut === true);
        });
        this.$el.toggleClass("component-cut", this.model.isInClipboard === true && this.model.isCut === true);
    },

    setupDnd: function() {
        var _this = this;

        this.$el.drop(function(_source, context) {
            // Empty view has special empty node
            if (_this.model.metaObject.type === "empty-node-model") {
                return;
            }

            // Select area
            if (context?.proxy) {
                var isSelection = $(context.proxy).data("type") === "selection";
                if (isSelection) {
                    _this.model.isSelected = true;
                }
            }
        });
    },

    onNodeClick: function(e) {
        e.stopPropagation();
        e.preventDefault();
        App.vent.trigger("metadata-browser:close");

        if (this._isMoving || this.model.isMissing) {
            return;
        }

        this.trigger("select-single-node", this.model);
    },

    onConnectNewNode: function(e) {
        e.stopPropagation();
        e.preventDefault();

        this.trigger("connect-new-node");
    },

    setRecentDataRate: function() {
        if (!this.ui.counter.html) {
            this.$el.find(this.ui.counter).html("---");
            return;
        }

        // statistics not assigned
        if (this.model.recentDataRate === -1) {
            this.ui.counter.html("");
            this.ui.counter.attr("title", "");
            return;
        }

        // server returned empty value for statistics
        if (typeof this.model.recentDataRate === "undefined" || this.model.recentDataRate === null) {
            this.ui.counter.html("Fetching…");
            this.ui.counter.attr("title", "Server statistics not available yet");
            return;
        }

        var message = this.model.recentDataRate + " records/s";

        if (this.model.additionalStatisticsInfo) {
            message = this.model.additionalStatisticsInfo + ", " + message;
        }

        this.ui.counter.html(message);
        this.ui.counter.attr("title", "");
    },

    toggleRecentDataVisibility: function() {},

    setConnectNewNodeVisibile: function() {},

    setNodeStates: function() {
        if (this.model.metaObject.metaInfoStatus) {
            this.$el.toggleClass("invalid", !this.model.metaObject.metaInfoStatus.isValid);
        }
        this.$el.toggleClass("external", this.model.isExternal);
        this.$el.toggleClass("missing", this.model.isMissing);
    },

    // true when move event was executed after mouseDown event
    _isMoving: false,

    // element position saved when mouseDown event was executed
    _savedPosition: null,

    onNodeMouseDown: function() {
        this._isMoving = false;
        this._savedPosition = this.$el.position();
    },

    onNodeMouseUp: function() {
        if (!this._isMoving) {
            return;
        }
        var position = this.$el.position();

        if (!this._isNodePositionChanged(position)) {
            return;
        }

        position.left = position.left - this._savedPosition.left;
        position.top = position.top - this._savedPosition.top;
        this.trigger("layout-position-changed", position);
    },

    _isNodePositionChanged: function(currentPosition) {
        if (!currentPosition || !this._savedPosition) {
            return;
        }

        return currentPosition.top !== this._savedPosition.top || currentPosition.left !== this._savedPosition.left;
    },

    onNodeMouseMove: function() {
        if (this._isMoving) {
            return;
        }

        var position = this.$el.position();

        if (this._isNodePositionChanged(position)) {
            this._isMoving = true;
        }
    },

    onRender: function() {
        this.$el.attr("id", this.model.elementId);
        this.setNodeStates();
    }
});
